import React from "react";
import { useNavigate } from "react-router-dom";

import { usePermissions } from "../permissions/permissions.hooks";
import { useAuth } from "./auth.hooks";

export function isScopedPartnerUser(
  hasPermission: (code: string) => boolean,
): boolean {
  return (
    hasPermission("partner:self:view") && !hasPermission("partners:view")
  );
}

export function getPartnerDetailPath(
  isScopedPartner: boolean,
  clientId: string | undefined,
  organizationRootId: string | undefined,
): string {
  if (isScopedPartner) {
    const id = clientId?.trim() || organizationRootId?.trim();
    return id ? `/clients/${id}` : "/dashboard";
  }
  return "/clients";
}

export function useScopedPartnerNav(clientId?: string) {
  const { auth } = useAuth();
  const { hasPermission } = usePermissions();
  const isScopedPartner = isScopedPartnerUser(hasPermission);
  const organizationRootId = auth.organization_root_id?.trim();

  const partnerHomePath = React.useMemo(
    () =>
      getPartnerDetailPath(isScopedPartner, clientId, organizationRootId),
    [isScopedPartner, clientId, organizationRootId],
  );

  return {
    isScopedPartner,
    organizationRootId,
    partnerHomePath,
  };
}

/** Impede voltar do navegador para a listagem `/clients` (Parceiro Master). */
export function useBlockPartnerListBack(isScopedPartner: boolean, organizationRootId?: string) {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isScopedPartner || !organizationRootId) {
      return;
    }

    const onPopState = () => {
      requestAnimationFrame(() => {
        const path = window.location.pathname;
        if (path === "/clients" || path === "/clients/") {
          navigate(`/clients/${organizationRootId}`, { replace: true });
        }
      });
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [isScopedPartner, organizationRootId, navigate]);
}
